type Space = {
	code: string;
	name: string;
	icon: string;
	extra?: boolean; // Indicates if this is an extra space type
	web?: boolean; // Indicates if this space is available on the web
	furnishingDetails?: { code: string; name: string }[]; // Furnishing details for this space
	color?: string; // Optional color for UI representation
	grouped?: string; // Grouping category for the space
};

const spaces: Space[] = [
	{
		code: "hall",
		name: "Hall",
		icon: "hall",
	},
	{
		code: "kitchen",
		name: "Kitchen",
		icon: "kitchen",
	},
	{
		code: "bedrooms",
		name: "Bedrooms",
		icon: "bedroom",
	},
	{
		code: "bathrooms",
		name: "Bathrooms",
		icon: "bathroom",
	},
	{
		code: "parking",
		name: "Parking",
		icon: "parking",
	},
	{
		code: "balcony",
		name: "Balcony",
		icon: "balcony",
	},
	{
		code: "servantRoom",
		name: "Servant Room",
		icon: "servant-room",
	},
	{
		code: "utility",
		name: "Utility",
		icon: "utility",
	},
];

const spaceTypes = [
	{
		code: "backYards",
		extra: true,
		icon: "backYard",
		name: "Back Yard",
		color: "grey",
		furnishingDetails: [],
		grouped: "outdoor",
	},
	{
		code: "balconies",
		extra: false,
		icon: "balcony",
		name: "Balcony",
		color: "light-blue darken-1",
		furnishingDetails: [],
		grouped: "outdoor",
	},
	{
		code: "bathrooms",
		extra: false,
		icon: "bathroom",
		name: "Bathroom",
		color: "pink darken-1",
		furnishingDetails: [
			{ code: "geysers", name: "Geysers" },
			{ code: "bathTubs", name: "Bath Tubs" },
			{ code: "jacuzzi", name: "Jacuzzi" },
		],
		grouped: "rooms",
	},
	{
		code: "bedrooms",
		extra: false,
		icon: "bedroom",
		name: "Bedroom",
		color: "red",
		furnishingDetails: [
			{ code: "tvCabinet", name: "TV Cabinet" },
			{ code: "wardrobes", name: "Wardrobes" },
			{ code: "dressingTable", name: "Dressing Table" },
			{ code: "expensivePaintings", name: "Expensive Paintings" },
			{ code: "decorativeElectricalFittings", name: "Decorative Electrical Fittings" },
			{ code: "storageCabinets", name: "Storage Cabinets" },
		],
		grouped: "rooms",
	},
	{
		code: "frontYards",
		extra: true,
		icon: "frontYard",
		name: "Front Yard",
		color: "blue-grey",
		furnishingDetails: [],
		grouped: "outdoor",
	},
	{
		code: "gardens",
		extra: true,
		icon: "garden",
		name: "Garden",
		color: "green accent-2",
		furnishingDetails: [],
		grouped: "outdoor",
	},
	{
		code: "halls",
		extra: true,
		icon: "hall",
		name: "Hall",
		color: "yellow darken-2",
		furnishingDetails: [
			{ code: "tvCabinet", name: "TV Cabinet" },
			{ code: "wardrobes", name: "Wardrobes" },
			{ code: "dressingTable", name: "Dressing Table" },
			{ code: "expensivePaintings", name: "Expensive Paintings" },
			{ code: "decorativeElectricalFittings", name: "Decorative Electrical Fittings" },
			{ code: "storageCabinets", name: "Storage Cabinets" },
		],
		grouped: "rooms",
	},
	{
		code: "kitchens",
		extra: true,
		icon: "kitchen",
		name: "Kitchen",
		color: "orange",
		furnishingDetails: [
			{ code: "kitchenCabinet", name: "Kitchen Cabinet" },
			{ code: "kitchenChimney", name: "Kitchen Chimney" },
			{ code: "ovens", name: "Ovens" },
		],
		grouped: "rooms",
	},
	{
		code: "parkings",
		web: true,
		icon: "parking",
		name: "Parking",
		color: "cyan",
		furnishingDetails: [],
		grouped: "special",
	},
	{
		code: "poojaRooms",
		web: true,
		extra: true,
		icon: "poojaRoom",
		name: "Pooja Room",
		color: "brown",
		furnishingDetails: [],
		grouped: "special",
	},
	{
		code: "servantRooms",
		web: true,
		extra: true,
		icon: "servantRoom",
		name: "Servant Room",
		color: "indigo",
		furnishingDetails: [],
		grouped: "rooms",
	},
	{
		code: "servantBathrooms",
		web: true,
		extra: true,
		icon: "servantBathroom",
		name: "Servant Bathroom",
		color: "indigo",
		furnishingDetails: [],
		grouped: "rooms",
	},
	{
		code: "sitouts",
		extra: true,
		icon: "sitout",
		name: "Sit Out",
		color: "teal",
		furnishingDetails: [],
		grouped: "outdoor",
	},
	{
		code: "studies",
		web: true,
		extra: true,
		icon: "study",
		name: "Study Only",
		color: "amber",
		furnishingDetails: [
			{ code: "wardrobes", name: "Wardrobes" },
			{ code: "storageCabinets", name: "Storage Cabinets" },
		],
		grouped: "rooms",
	},
	{
		code: "halfBedrooms",
		extra: true,
		name: "Study/Half Bedroom",
		furnishingDetails: [],
		grouped: "rooms",
	},
	{
		code: "terraces",
		extra: true,
		icon: "terrace",
		name: "Terrace",
		color: "blue",
		furnishingDetails: [],
		grouped: "outdoor",
	},
	{
		code: "utilities",
		extra: true,
		icon: "utility",
		name: "Utility",
		color: "purple",
		furnishingDetails: [
			{ code: "wardrobes", name: "Wardrobes" },
			{ code: "storageCabinets", name: "Storage Cabinets" },
		],
		grouped: "rooms",
	},
	{
		code: "storeRooms",
		extra: true,
		icon: "storeRooms",
		name: "Store Room",
		furnishingDetails: [],
		grouped: "rooms",
	},
	{
		code: "project",
		web: true,
		extra: false,
		name: "Project",
		furnishingDetails: [],
		grouped: "project",
	},
	{
		code: "approachRoad",
		web: true,
		extra: false,
		name: "Approach Road",
		furnishingDetails: [],
		grouped: "project",
	},
	{
		code: "exteriors",
		web: true,
		extra: false,
		name: "Exteriors",
		furnishingDetails: [],
		grouped: "project",
	},
	{
		code: "others",
		extra: false,
		icon: "otherSpace",
		name: "Others",
		color: "light-green darken-2",
		furnishingDetails: [],
		grouped: "misc",
	},
];

export { spaces, spaceTypes, type Space };
